import { createContext, FC, ReactNode, use } from 'react'

import { AuthenticatedUser } from './types'

const AuthenticatedUserContext = createContext<AuthenticatedUser | undefined>(
  undefined,
)

export const AuthenticatedUserProvider: FC<{
  authenticatedUser: AuthenticatedUser
  children: ReactNode
}> = ({ authenticatedUser, children }) => {
  return (
    <AuthenticatedUserContext.Provider value={authenticatedUser}>
      {children}
    </AuthenticatedUserContext.Provider>
  )
}

export const useAuthenticatedUser = (): AuthenticatedUser => {
  const authenticatedUser = use(AuthenticatedUserContext)
  if (!authenticatedUser) {
    throw new Error(
      'useAuthenticatedUser must be used within a AuthenticatedUserProvider',
    )
  }
  return authenticatedUser
}
